"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Certiblok Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.8.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CalendarApi = exports.CalendarApiFactory = exports.CalendarApiFp = exports.CalendarApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
/**
 * CalendarApi - axios parameter creator
 * @export
 */
const CalendarApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Get calendar events
         * @param {string} startDate
         * @param {string} endDate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCalendarEvents: (startDate, endDate, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'startDate' is not null or undefined
            (0, common_1.assertParamExists)('getCalendarEvents', 'startDate', startDate);
            // verify required parameter 'endDate' is not null or undefined
            (0, common_1.assertParamExists)('getCalendarEvents', 'endDate', endDate);
            const localVarPath = `/calendar/events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication headerAuth required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "authorization", configuration);
            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate instanceof Date) ?
                    startDate.toISOString().substr(0, 10) :
                    startDate;
            }
            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate instanceof Date) ?
                    endDate.toISOString().substr(0, 10) :
                    endDate;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get expiring calendar events
         * @param {string} startDate
         * @param {string} endDate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExpiringCalendarEvents: (startDate, endDate, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'startDate' is not null or undefined
            (0, common_1.assertParamExists)('getExpiringCalendarEvents', 'startDate', startDate);
            // verify required parameter 'endDate' is not null or undefined
            (0, common_1.assertParamExists)('getExpiringCalendarEvents', 'endDate', endDate);
            const localVarPath = `/calendar/expiring`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication headerAuth required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "authorization", configuration);
            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate instanceof Date) ?
                    startDate.toISOString().substr(0, 10) :
                    startDate;
            }
            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate instanceof Date) ?
                    endDate.toISOString().substr(0, 10) :
                    endDate;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.CalendarApiAxiosParamCreator = CalendarApiAxiosParamCreator;
/**
 * CalendarApi - functional programming interface
 * @export
 */
const CalendarApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.CalendarApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Get calendar events
         * @param {string} startDate
         * @param {string} endDate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCalendarEvents(startDate, endDate, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCalendarEvents(startDate, endDate, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get expiring calendar events
         * @param {string} startDate
         * @param {string} endDate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExpiringCalendarEvents(startDate, endDate, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getExpiringCalendarEvents(startDate, endDate, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.CalendarApiFp = CalendarApiFp;
/**
 * CalendarApi - factory interface
 * @export
 */
const CalendarApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.CalendarApiFp)(configuration);
    return {
        /**
         *
         * @summary Get calendar events
         * @param {string} startDate
         * @param {string} endDate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCalendarEvents(startDate, endDate, options) {
            return localVarFp.getCalendarEvents(startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get expiring calendar events
         * @param {string} startDate
         * @param {string} endDate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExpiringCalendarEvents(startDate, endDate, options) {
            return localVarFp.getExpiringCalendarEvents(startDate, endDate, options).then((request) => request(axios, basePath));
        },
    };
};
exports.CalendarApiFactory = CalendarApiFactory;
/**
 * CalendarApi - object-oriented interface
 * @export
 * @class CalendarApi
 * @extends {BaseAPI}
 */
class CalendarApi extends base_1.BaseAPI {
    /**
     *
     * @summary Get calendar events
     * @param {string} startDate
     * @param {string} endDate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarApi
     */
    getCalendarEvents(startDate, endDate, options) {
        return (0, exports.CalendarApiFp)(this.configuration).getCalendarEvents(startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get expiring calendar events
     * @param {string} startDate
     * @param {string} endDate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarApi
     */
    getExpiringCalendarEvents(startDate, endDate, options) {
        return (0, exports.CalendarApiFp)(this.configuration).getExpiringCalendarEvents(startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.CalendarApi = CalendarApi;
